export const normalizeSearchString = str => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
};
export const handleFilteredItems = (items, filterTerm) => {
  return items.filter(item => normalizeSearchString(item.label).includes(normalizeSearchString(filterTerm)));
};